import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ListItemComponent} from '@abstract/list-items/list-item.component';
import {Conclusion} from '@namespaces/conclusion.namespace';
import {RoutesStorage} from '@helpers/routes.helper';
import {PreviewModalService} from '@services/preview-modal.service';
import {UploadedFile} from '@interfaces/file.interface';

@Component({
    selector: 'tr[app-conclusion-list-item]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'conclusion-list-item.component.html'
})

export class ConclusionListItemComponent extends ListItemComponent {

    constructor(
        private filesPreviewService: PreviewModalService,
    ) {
        super();
    }

    @Input() item: Conclusion.ListViewItem;
    @Input() selectedValues: number[] = [];

    public conclusionRouteBuilder = RoutesStorage.Conclusion;

    showScan(scan: UploadedFile) {
        this.filesPreviewService.show({
            files: [scan]
        });
    }
}
